import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import PaymentCheckbox from './PaymentCheckbox';
import PaymentHourEditModal from './PaymentHourEditModal';
import getLocale from '../../i18n/getLocale';

class PaymentHoursOpened extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      payment_order_id: '',
      training_certification_staff_payments: [],
      payment_orders_list: [],
      checkbox_marked_ids: [],
      data_payment_hour: [],
      checkbox_changed: 0,
      modal_props: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.PaymentCheckbox = this.PaymentCheckbox.bind(this);
    this.unmarkAllCheckbox = this.unmarkAllCheckbox.bind(this);
    this.markAllCheckbox = this.markAllCheckbox.bind(this);
    this.markedCheckboxId = this.markedCheckboxId.bind(this);
    this.UnmarkCheckboxId = this.UnmarkCheckboxId.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);

    this.locale = getLocale();
  }

  handleCheckboxChange(name, event) {
    // valor selecionado. Valor são true e false
    var value = event.target.checked;
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = value;
      if (value) {
        this.markAllCheckbox();
      } else {
        this.unmarkAllCheckbox();
      }
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/horas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_staff_payments: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/ordens/pagamento/lista/missao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_orders_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de ordens de pagamento */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
    this.modalPropsOff();
  }
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/horas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_staff_payments: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
        self.modalPropsOff();
        self.setState({checkbox_marked_ids: []});
        self.unmarkAllCheckbox();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadDataEditModal(value, event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var id = (value);
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/editar/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_payment_hour:responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.showModal();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      checkbox_marked_ids: this.state.checkbox_marked_ids,
      payment_order_id: this.state.payment_order_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento/incluir/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(event) {
    event.preventDefault();
    var confirm = window.confirm(this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.deletarPagamentosSelecionados);
    if (confirm) {
      var datasave = {
        checkbox_marked_ids: this.state.checkbox_marked_ids,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/deletar/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  ActionsButtons (cell, row) {
    var url = "";
    var botao = (
      <div className="btn-group">
        <button onClick={this.loadDataEditModal.bind(this, cell)} className='btn btn-sm btn-primary' alt={this.locale.general.editar} title={this.locale.general.editar}><i className="fa fa-fw fa-pencil"></i></button>
      </div>
    );

    return botao;
  }

  PaymentCheckbox (cell, row) {
    var botao = (
      <div>
        <PaymentCheckbox handleAlert={this.handleAlert} markedCheckboxId={this.markedCheckboxId} UnmarkCheckboxId={this.UnmarkCheckboxId} checkbox_marked_ids={this.state.checkbox_marked_ids} training_certification_staff_payment_id={cell} />
      </div>
    );

    return botao;
  }

  unmarkAllCheckbox () {
    this.setState({checkbox_marked_ids: []});
  }

  markAllCheckbox () {
    var self = this;
    var ids_temp = [];
    Object.keys(self.state.training_certification_staff_payments).map(function(k) {
      ids_temp.push(self.state.training_certification_staff_payments[k].id);
    });
    self.setState({checkbox_marked_ids: ids_temp});
  }

  markedCheckboxId (value) {
    var ids_temp = this.state.checkbox_marked_ids;
    ids_temp.push(value);
    this.setState({checkbox_marked_ids: ids_temp});
  }

  UnmarkCheckboxId (value) {
    var self = this;
    var ids_temp = [];
    var checkbox_ids = this.state.checkbox_marked_ids;
    checkbox_ids.map(function(checked_id) {
      if(checked_id !== value) {
        ids_temp.push(checked_id);
      }
    });
    self.setState({checkbox_marked_ids: ids_temp});
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <Link to="/pagamento/horas/cadastrar" className="btn btn-info"><i className="fa fa-plus"></i> {this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.botaoCadastrarPagamento}</Link>
      <hr/>
      <h3 className="page-title pull-left">{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.titulo}</h3>
      <Link to="/certificados" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
          <div className="form-group">
            <label>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formulario.OrdemDePagamento}:</label>
            <Select
              className="form-field-name"
              name="payment_order_id"
              value={this.state.payment_order_id}
              searchable={true}
              placeholder={this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formulario.placeholder.SelecionarOrdemDePagamento}
              onChange={this.handleSelectChange.bind(this, 'payment_order_id')}
              options={this.state.payment_orders_list}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formulario.botaoAdicionarAOrdemDePagamento}</button>
          <button type="button" onClick={this.delete} className="btn btn-danger btn-block"><i className="fa fa-fw fa-trash"></i> {this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.formulario.botaoDeletarPagamentos}</button>
      </form>
      <hr/>
      <BootstrapTable data={this.state.training_certification_staff_payments} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Acoes}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="certification_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.TipoDeTreinamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="certification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Aula}</TableHeaderColumn>
        <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Periodo}</TableHeaderColumn>
        <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Treinamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.NumeroERev}</TableHeaderColumn>
        <TableHeaderColumn dataField="supplier" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.Local}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_paid_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.HorasPagas}</TableHeaderColumn>
        <TableHeaderColumn dataField="hour_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.ValorDaHora}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PagamentosDeEscala.ListaDePagamentosEmAbertoHoras.tabela.TotalDeHoras}</TableHeaderColumn>
      </BootstrapTable>
      <PaymentHourEditModal handleAlert={this.props.handleAlert} modal_props={this.state.modal_props} data_payment_hour={this.state.data_payment_hour} refreshTable={this.refreshTable} />
    </div>
  </div>
</div>
    );
  }
}

export default PaymentHoursOpened;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentHoursOpened.js